import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Shrinkable extends Component {

  static propTypes = {
    minWidth: PropTypes.number.isRequired,
    minHeight: PropTypes.number.isRequired,
    children: PropTypes.node.isRequired,
  };

  state = {
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
  };

  componentDidMount() {
    window.addEventListener('resize', () => {
      this.setState({
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
      });
    });
  }

  render() {
    const minWidth = this.props.minWidth;
    const minHeight = this.props.minHeight;

    const { windowWidth, windowHeight } = this.state;

    let transformOrigin = 'center 0'; // same as "50% 0"
    let scale = 1.0;
    if (minWidth && windowWidth && (windowWidth < minWidth)) {
      scale = windowWidth / minWidth;
      transformOrigin = '0 0'; // Slide it to the left
    }
    if (minHeight && windowHeight && (windowHeight < minHeight)) {
      if (scale > (windowHeight / minHeight)) {
        scale = windowHeight / minHeight;
        if (transformOrigin === '0 0') {
          // Annoying corner case:
          // Both height and width are too small, but the height situation is worse.
          // We need horizontal centering, so we want to adjust transformOrigin.
          // When windowWidth == scale * minWidth we want transformOrigin "0% 0" (factor 0.0).
          // When windowWidth == minWidth we want transformOrigin "50% 0" (factor 1.0).
          // Linear interpolation from 0 to 1 yields correct values at the two endpoints
          // (so there is no jumping around on window resizes) but values midway through are low.
          // But if we use the square root of our interpolated value, this problem seems to go away!
          const factor = Math.sqrt((windowWidth - scale * minWidth) / (minWidth - scale * minWidth));
          transformOrigin = `${50 * factor}% 0`;
        }
      }
    }

    return (
      <div
        style={{
          width: 'inherit',
          height: 'inherit',
          transform: `scale(${scale})`,
          transformOrigin,
        }}
      >
        {
          React.Children.toArray(this.props.children)
        }
      </div>
    );
  }
}

export default Shrinkable;
